

(function () {
  'use strict';

  var MOBILE = '(max-width:700px)';
  var isMobile = function () { return window.matchMedia(MOBILE).matches; };
  var reduced = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var call = document.getElementById('call');

  

  (function () {
    var pending = [].slice.call(document.querySelectorAll('.pp-defer'));
    if (!pending.length) return;
    var done = false;
    function promote() {
      if (done) return;
      done = true;
      pending.forEach(function (img) {
        var pic = img.parentNode;
        var src = pic && pic.querySelector ? pic.querySelector('source[data-srcset]') : null;
        if (src) src.srcset = src.dataset.srcset;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
        img.classList.remove('pp-defer');
      });
    }
    if (document.readyState === 'complete') setTimeout(promote, 0);
    else window.addEventListener('load', promote, { once: true });
    var track = document.querySelector('.mtrack');
    if (track) ['touchstart', 'pointerdown', 'wheel'].forEach(function (e) {
      track.addEventListener(e, promote, { passive: true, once: true });
    });
  })();

  (function () {
    var track = document.querySelector('.mtrack');
    if (!track) return;
    var dots = document.querySelectorAll('.mdots i');
    var figs = track.querySelectorAll('figure');
    var credit = document.querySelector('.mslider .credit');
    var n = figs.length, cur = 0, timer = null, idle = null;

    function sync() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i === cur || i < 0 || i >= n) return;
      cur = i;
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('on', j === i);
      if (credit) credit.textContent = figs[i].dataset.credit || '';
    }
    track.addEventListener('scroll', sync, { passive: true });

    function go(i) {
      track.scrollTo({ left: i * track.clientWidth, behavior: reduced() ? 'auto' : 'smooth' });
    }
    function tick() {
      if (reduced() || document.hidden) return;
      go((cur + 1) % n);
    }
    

    function interval() {
      var attr = isMobile() ? 'data-interval-mobile' : 'data-interval';
      var ms = parseInt(track.getAttribute(attr), 10);
      if (!isFinite(ms) || ms < 800) ms = isMobile() ? 3200 : 3600;
      return ms;
    }
    function start() {
      stop();
      timer = setTimeout(function () { tick(); start(); }, interval());
    }
    function stop() { if (timer) { clearTimeout(timer); timer = null; } }
    function pause() { stop(); clearTimeout(idle); idle = setTimeout(start, 7000); }

    

    ['touchstart', 'pointerdown', 'wheel', 'mouseenter', 'focusin'].forEach(function (e) {
      track.addEventListener(e, pause, { passive: true });
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  })();

  

  (function () {
    var tp = document.querySelector('.trust .tp');
    if (tp) tp.setAttribute('aria-label', 'Excellent, 4.7 out of 5 on Trustpilot. Opens in a new tab.');
  })();

  (function () {
    var vids = [].slice.call(document.querySelectorAll('.p8 video'));
    vids.forEach(function (v) {
      var card = v.closest('article');
      var btn = card && card.querySelector('.play');
      v.addEventListener('play', function () {
        if (card) card.classList.add('playing');
        vids.forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
      });
      v.addEventListener('pause', function () { if (card) card.classList.remove('playing'); });
      v.addEventListener('ended', function () { if (card) card.classList.remove('playing'); });
      if (btn) {
        btn.addEventListener('click', function () { v.play(); });
        var who = card && card.querySelector('.n, h3');
        

        var name = who && (who.firstChild && who.firstChild.nodeType === 3
          ? who.firstChild.nodeValue : who.textContent);
        if (name) btn.setAttribute('aria-label', 'Play video: ' + name.replace(/\s+/g, ' ').trim());
      }
    });
  })();

  (function () {
    if (!call) return;
    var sticky = document.getElementById('sticky');
    var cityform = document.querySelector('.cityform');
    

    var claim = document.getElementById('ppclaim');
    var claimOff = false;
    try {
      claimOff = window.sessionStorage.getItem('gkw_pp_sticky_x') === '1' ||
                 window.sessionStorage.getItem('gkw_wp_submitted') === '1';
    } catch (e) {}

    if (sticky && 'IntersectionObserver' in window) {
      var inCall = false, inHero = true, typing = false, settle = null;
      

      var apply = function () {
        var off = inCall || inHero || typing;
        sticky.classList.toggle('hide', off);
        if (claim) claim.classList.toggle('hide', off || claimOff);
      };
      var upd = function () {
        if (settle) clearTimeout(settle);
        settle = setTimeout(function () { settle = null; apply(); }, 120);
      };
      

      document.addEventListener('focusin', function (e) {
        if (claim && claim.contains(e.target)) return;
        if (e.target.matches('input,select,textarea')) { typing = true; apply(); }
      });
      document.addEventListener('focusout', function (e) {
        if (claim && claim.contains(e.target)) return;
        typing = false; apply();
      });
      new IntersectionObserver(function (e) { inCall = e[0].isIntersecting; upd(); }, { threshold: 0.15 }).observe(call);
      

      if (cityform) new IntersectionObserver(function (e) { inHero = e[0].isIntersecting; upd(); }, { threshold: 0.05, rootMargin: '40px 0px 40px 0px' }).observe(cityform);
      apply();
    }

    if (claim) {
      

      var cform = claim.querySelector('form');
      if (cform) {
        cform.addEventListener('submit', function (ev) {
          ev.preventDefault();
          var v = (cform.city.value || '').trim();
          var lead = document.querySelector('form[data-pp-form]');
          var cityInput = lead && lead.querySelector('[name="contact[City and country]"]');
          if (v && cityInput) cityInput.value = v;
          call.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
          setTimeout(function () {
            var nameInput = lead && lead.querySelector('[name="contact[name]"]');
            var target = v ? nameInput : cityInput;
            if (target) target.focus({ preventScroll: true });
          }, 600);
        });
      }
      var xbtn = claim.querySelector('.x');
      if (xbtn) {
        xbtn.addEventListener('click', function () {
          claimOff = true;
          try { window.sessionStorage.setItem('gkw_pp_sticky_x', '1'); } catch (e) {}
          claim.classList.add('hide');
        });
      }
    }

    document.querySelectorAll('a[href="#call"]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        call.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
        setTimeout(function () {
          var f = call.querySelector('input');
          if (f && isMobile()) f.focus({ preventScroll: true });
        }, 600);
      });
    });
  })();

  document.querySelectorAll('.scr').forEach(function (row) {
    var kids = row.children, dir = 1, t = null, idle = null;
    var period = row.classList.contains('kgrid10') ? 2200 : 3800;
    var gutter = 18;

    function inview() { var r = row.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; }
    function playing() {
      return [].some.call(row.querySelectorAll('video'), function (v) { return !v.paused; });
    }
    function step() {
      if (!isMobile() || reduced() || !inview() || document.hidden || playing()) return;
      var x = row.scrollLeft, max = row.scrollWidth - row.clientWidth, next = null;
      var rl = row.getBoundingClientRect().left;
      for (var i = 0; i < kids.length; i++) {
        var l = Math.round(x + kids[i].getBoundingClientRect().left - rl - gutter);
        if (dir > 0 && l > x + 4) { next = l; break; }
        if (dir < 0 && l < x - 4) next = l;
      }
      if (next === null || (dir > 0 && next > max)) { dir = -dir; next = dir > 0 ? 0 : max; }
      row.scrollTo({ left: Math.max(0, Math.min(next, max)), behavior: 'smooth' });
    }
    function start() { stop(); t = setInterval(step, period); }
    function stop() { if (t) { clearInterval(t); t = null; } }
    function pause() { stop(); clearTimeout(idle); idle = setTimeout(start, 8000); }

    ['touchstart', 'pointerdown', 'wheel', 'mouseenter', 'focusin'].forEach(function (e) {
      row.addEventListener(e, pause, { passive: true });
    });
    row.querySelectorAll('video').forEach(function (v) { v.addEventListener('play', pause); });
    start();
  });

  var form = document.querySelector('form[data-pp-form]');

  

  (function () {
    var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var utm = {};
    try {
      var sp = new URLSearchParams(window.location.search);
      KEYS.forEach(function (k) { var v = sp.get(k); if (v) utm[k] = v; });
      if (Object.keys(utm).length) {
        window.sessionStorage.setItem('gkw_pp_utm', JSON.stringify(utm));
      } else {
        utm = JSON.parse(window.sessionStorage.getItem('gkw_pp_utm') || '{}') || {};
      }
    } catch (e) { utm = {}; }
    if (!form) return;
    var line = KEYS.map(function (k) { return utm[k] ? k + '=' + utm[k] : null; })
      .filter(Boolean).join(' | ');
    var f = form.querySelector('[data-pp-utm]');
    if (f) f.value = line || 'none';
    var ref = form.querySelector('[data-pp-referrer]');
    if (ref) { try { ref.value = document.referrer || 'direct'; } catch (e) {} }
  })();

  if (form) {
    var cityform = document.getElementById('cityform');
    if (cityform) {
      cityform.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = (cityform.hero_city.value || '').trim();
        var c = form.querySelector('[name="contact[City and country]"]');
        if (v && c) c.value = v;
        if (call) call.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth' });
        setTimeout(function () {
          var target = v ? form.querySelector('[name="contact[name]"]') : c;
          if (target) target.focus({ preventScroll: true });
        }, 600);
      });
    }

    form.addEventListener('submit', function (e) {
      var _n = form.elements['contact[Anything we should know]'];
      if (_n) _n.value = String(_n.value || '').replace(/Company\s*Website\s*:/gi, 'Company site:');

      var ok = true, first = null;
      form.querySelectorAll('[required]').forEach(function (i) {
        var bad = !i.value || (i.checkValidity && !i.checkValidity());
        if (bad) {
          if (!i.value) ok = false;
          i.classList.add('err'); i.setAttribute('aria-invalid', 'true');
          if (!first) first = i;
        } else { i.classList.remove('err'); i.removeAttribute('aria-invalid'); }
      });
      if (!ok) {
        e.preventDefault();
        if (first) { first.focus(); first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return;
      }
      klaviyo(form);
    });

    

    var WP_LIST_ID = 'RkYwUk';
    var KLAVIYO_COMPANY = 'TY4TiA';
    var KL_HEADERS = { 'Content-Type': 'application/vnd.api+json', revision: '2025-04-15' };

    function klaviyo(f) {
      var val = function (n) {
        var el = f.elements[n];
        return el ? String(el.value || '').trim() : '';
      };
      var hp = f.querySelector('[data-pp-hp]');
      if (hp && String(hp.value || '').trim()) return;
      if (hp) hp.disabled = true;

      var btn = f.querySelector('button[type="submit"]');
      if (btn && !btn.disabled) { btn.disabled = true; btn.textContent = 'Sending\u2026'; }

      try { window.sessionStorage.setItem('gkw_wp_submitted', '1'); } catch (e) {}

      var email = val('contact[email]');
      if (!email) return;
      var whole = val('contact[name]');
      var cut = whole.indexOf(' ');
      var first_name = cut === -1 ? whole : whole.slice(0, cut);
      var last_name = cut === -1 ? '' : whole.slice(cut + 1).trim();
      var props = {
        wp_city: val('contact[City and country]'),
        wp_classes: val('contact[Guitar classes]'),
        wp_website: val('contact[Website or social media]'),
        wp_notes: val('contact[Anything we should know]')
      };
      var utmLine = '';
      var uf = f.querySelector('[data-pp-utm]');
      if (uf) utmLine = String(uf.value || '');

      var post = function (path, body) {
        try {
          window.fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + KLAVIYO_COMPANY, {
            method: 'POST', mode: 'cors', keepalive: true,
            headers: KL_HEADERS, body: JSON.stringify(body)
          }).catch(function () {});
        } catch (e) {}
      };

      post('events', {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Workshop Call Requested' } } },
            properties: {
              wp_city: props.wp_city,
              wp_classes: props.wp_classes,
              wp_website: props.wp_website,
              wp_notes: props.wp_notes,
              wp_utm: utmLine,
              wp_source: 'pages/workshops'
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: first_name,
                  last_name: last_name,
                  properties: props
                }
              }
            }
          }
        }
      });

      if (!WP_LIST_ID) return;
      post('subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'workshop-partner-lander',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: first_name,
                  last_name: last_name,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: WP_LIST_ID } } }
        }
      });
    }
    form.addEventListener('input', function (e) {
      var el = e.target;
      if (el.hasAttribute && el.hasAttribute('data-pp-tel')) {
        var clean = el.value.replace(/[^0-9()+\-.\s]/g, '');
        if (clean !== el.value) {
          var at = el.selectionStart - (el.value.length - clean.length);
          el.value = clean;
          try { el.setSelectionRange(at, at); } catch (err) {}
        }
      }
      if (el.value && (!el.checkValidity || el.checkValidity())) {
        el.classList.remove('err'); el.removeAttribute('aria-invalid');
      }
    });
  }
})();
